import React from "react";
import PropTypes from "prop-types";

import EmptyStateMessage from "shared/react_components/EmptyStates/EmptyStateMessage";

// Avoid using this component directly. Please refer to the EmptyStates storybook folder for higher level reusable components
const EmptyStateTemplate = ({ height, width, headerFontSize, messageFontSize, headerMessage, message, emptyStateImage: EmptyStateImage }) => (
  <div className="d-flex align-items-center justify-content-center flex-column">
    <EmptyStateImage width={width} height={height}/>
    <EmptyStateMessage
      width={width}
      headerFontSize={headerFontSize}
      messageFontSize={messageFontSize}
      headerMessage={headerMessage}
      message={message}/>
  </div>
);

EmptyStateTemplate.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  headerFontSize: PropTypes.string.isRequired,
  messageFontSize: PropTypes.string.isRequired,
  headerMessage: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  emptyStateImage: PropTypes.elementType.isRequired
};

export default EmptyStateTemplate;
